import { axios, type MutationFetcher, type SWRKey, useSWRMutation } from 'services/swr';

export type NpsScorePayload = unknown;

export const npsStorageKeys = {
    submitted: 'md_nps.submitted',
    snoozeUntil: 'md_nps.snoozeUntilMs',
    visits: 'md_nps.dashboardVisits',
    resultsVisits: 'md_nps.resultsVisits',
    lastResultId: 'md_nps.lastResultId',
    pendingResultsPrompt: 'md_nps.pendingResultsPrompt',
} as const;

const sendNpsScore: MutationFetcher<unknown, SWRKey, NpsScorePayload> = async ({ url, ...config }, { arg: data }) => {
    return axios.post(url, data, config).then((res) => res.data);
};

export const useSendNpsScore = () => {
    const reportKey: SWRKey = { url: '/v4/apikey/nps' };
    return useSWRMutation(reportKey, sendNpsScore, { revalidate: false });
};
